import { createContext, useContext, type ReactNode } from "react"

import { portalApi, type PortalApi } from "./api"

/**
 * The one seam between the portal and its data.
 *
 * Every section reads the api from here rather than importing the live object,
 * so the whole app can be handed a different conversation without a second
 * implementation of a single screen. The demo in ./demo is the only other
 * implementation, and it is typed against `PortalApi`, so a section that starts
 * asking for something new cannot leave the demo behind quietly.
 */
const PortalApiContext = createContext<PortalApi>(portalApi)

export function PortalApiProvider({
  api,
  children,
}: {
  api: PortalApi
  children: ReactNode
}) {
  return <PortalApiContext value={api}>{children}</PortalApiContext>
}

export const usePortalApi = (): PortalApi => useContext(PortalApiContext)
